import { render, staticRenderFns } from "./AddEditRoom.vue?vue&type=template&id=2d6f691d&scoped=true"
import script from "./AddEditRoom.vue?vue&type=script&lang=js"
export * from "./AddEditRoom.vue?vue&type=script&lang=js"
import style0 from "./AddEditRoom.vue?vue&type=style&index=0&id=2d6f691d&prod&scoped=true&lang=css"
import style1 from "./AddEditRoom.vue?vue&type=style&index=1&id=2d6f691d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d6f691d",
  null
  
)

export default component.exports